import * as THREE from 'three'
import { disposeO3D_child } from "../js/threejsHelper"
import { createMeshFromLine } from '@/utils/threejsHelper'

let model_group = null;
let delete_index = 5;
let visible = false;
/**
 * 加载shield_output 中的线 path
 * @param vehicleData 
 */
export const loadVehicle_shield_output_emergencysteering_path = (vehicleData, scene_param, vehicleParams) => {
    if (!vehicleData?.shieldOutput?.emergencySteering?.path) {
        delete_index--;
        if (delete_index > 0) {
            return;
        } else {
            clearGroupMap();
            return;
        }
    }
    let isvisible = localStorage.getItem("shield_ouput_path_local")
    clearGroupMap();
    if (isvisible != "1") return;
    delete_index = 5;
    if (!vehicleData?.shieldOutput?.emergencySteering?.path?.pathPointList) {
        return;
    }
    let line = createPath(vehicleData.shieldOutput?.emergencySteering?.path?.pathPointList, vehicleParams);
    if (!model_group) {
        model_group = new THREE.Group();
        scene_param.add(model_group);
    }
    model_group.add(line)
}


export const clear_vehicle_shield_output_emergencysteering_path = () => {
    clearGroupMap();
}

export const vehicle_shield_output_visible_emergencysteering_path = (menuList) => {
    if (model_group) {
        model_group.visible = menuList.includes('/shield/shield_result/emergencysteering/path')
    }
    visible = menuList.includes('/shield/shield_result/emergencysteering/path')
}


const material = new THREE.MeshBasicMaterial({
    color: 0x849228,
    side: THREE.DoubleSide,
    depthTest: true
})
function createPath(pointList = [], vehicleParams) {
    let heartShape = new THREE.Shape()
    let width = vehicleParams.width || 0.5
    let pointsList = createMeshFromLine(pointList, width)
    pointsList.forEach((e, index) => {
        if (index == 0) {
            heartShape.moveTo(e.x, e.y)
        } else {
            heartShape.lineTo(e.x, e.y)
        }
    })
    const geometry_shape = new THREE.ShapeGeometry(heartShape)
    const mesh = new THREE.Mesh(geometry_shape, material)
    mesh.position.set(0, 0, 0.017)
    mesh.renderOrder = 1
    return mesh;
}
const clearGroupMap = () => {
    disposeO3D_child(model_group)
}